import { useEffect } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { defaultPagePath } from './defaultPagePath';
import Portal from './Portal';
import { EUserRolesUI } from 'data/types/user.types';

const PublicRoute = ({ component: Component, usersData, ...rest }) => {
  // const showIntro = user?.attributes['custom:showIntro'];
  const { userType, impersonateOn } = usersData || {};
  const history = useHistory();
  useEffect(() => {
    if (usersData?.userType && !(userType === EUserRolesUI.ADMIN && !impersonateOn)) {
      history.push(defaultPagePath[userType].false);
    }
  }, [usersData]);
  return (
    <Route
      {...rest}
      render={(props) => (
        <Portal>
          <Component {...props} />
        </Portal>
      )}
    />
  );
};

export default PublicRoute;
